/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SuperSearchPageResult = {
  key: string;
  label: string;
  scope: SuperSearchPageResult.scope;
  required_feature_flag?: string;
};
export namespace SuperSearchPageResult {
  export enum scope {
    FIRM = 'firm',
    COMPANY = 'company',
  }
}

